import axios from 'axios';
import { authUser } from './userService';
import { getSubdomain } from '../utils/subdomain';

const API_URL = process.env.REACT_APP_EP_API;

export const getConfiguration = async () => {
  const loggedUser = authUser();
  const accessToken = loggedUser.accessToken;
  const authHeader = { 'Authorization': `Bearer ${accessToken}` };

  try {
    const response = await axios.get(`${API_URL}/administration/configuration`, {
      headers: {
        ...authHeader,
        'x-Company-Code': getSubdomain() || 'demo',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching configuration:', error.response ? error.response.data : error.message);
    throw error;
  }
};
